export type Event = string;

export const COMMAND_BAR_REFRESH_EVENT: Event = "COMMAND_BAR_REFRESH";
export const COMMAND_BAR_CANCEL_MATCHING: Event = "COMMAND_BAR_CANCEL_MATCHING";
export const COMMAND_BAR_CREATE_PARTNER: Event = "COMMAND_BAR_CREATE_PARTNER";
export const COMMAND_BAR_DELETE_PARTNER: Event = "COMMAND_BAR_DELETE_PARTNER";
export const COMMAND_BAR_CREATE_MATCHING: Event = "COMMAND_BAR_CREATE_MATCHING";
